import { EXCEL } from "@/constants/testIds";

/**
 * Field mapping grid: maps DB field names to Excel column names.
 * Props: columns (string[]), suggestedFields (string[]), requiredFields (string[]),
 *        mapping ({[dbField]: excelCol}), onChange (fn(newMapping))
 */
export function FieldMapper({ columns, suggestedFields, requiredFields, mapping, onChange }) {
  const handleChange = (dbField, excelCol) => {
    onChange({ ...mapping, [dbField]: excelCol });
  };

  return (
    <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
      {(suggestedFields || []).map((dbField) => (
        <div key={dbField} data-testid={`${EXCEL.fieldMappingRow}-${dbField}`}>
          <label className="block text-xs font-semibold text-slate-500 uppercase tracking-wider mb-1">
            {({cari_id: "Cari kodu / kimliği", dis_kayit_id: "Dış kayıt numarası", kaynak: "Kaynak sistem"})[dbField] || dbField}
            {requiredFields?.includes(dbField) && (
              <span className="text-red-500 ml-1">*</span>
            )}
          </label>
          <select
            value={mapping[dbField] || ""}
            onChange={(e) => handleChange(dbField, e.target.value)}
            className="w-full rounded-md border border-slate-300 px-2.5 py-2 text-xs bg-white focus:outline-none focus:ring-2 focus:ring-[#0D1B3E]/20"
          >
            <option value="">-- Atla --</option>
            {columns.map((c) => (
              <option key={c} value={c}>
                {c}
              </option>
            ))}
          </select>
        </div>
      ))}
    </div>
  );
}
